import { render } from "./DomainDetail.vue?vue&type=template&id=3ffb1bbb&scoped=true"
import script from "./DomainDetail.vue?vue&type=script&lang=js"
export * from "./DomainDetail.vue?vue&type=script&lang=js"

import "./DomainDetail.vue?vue&type=style&index=0&id=3ffb1bbb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffb1bbb"]])

export default __exports__